import { Component } from "@angular/core";

@Component({
  selector: "app-abm-enterprise-content",
  templateUrl: "abm-enterprise-content.component.html",
})
export class AbmEnterpriseContentComponent {}
